import { makeAutoObservable } from 'mobx'
import { createRef, RefObject } from 'react'
import NaverMapView from 'react-native-nmap'
import {
  GpsBounds,
  GpsLocation,
  LatLngDelta,
  LocationTrackingMode,
  NaverMapCamera,
  Place,
} from 'infra/type'
import { DEFAULT_ZOOM } from 'infra/constant'

export class MapStore {
  mapRef: RefObject<NaverMapView | null> = createRef()
  camera: NaverMapCamera | null = null
  isReady: boolean = false
  selectedPlace: Place | null = null
  selectedCategoryIds: number[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get rangeBounds(): GpsBounds | null {
    const c = this.camera
    if (!c || !Array.isArray(c.coveringRegion)) return null
    const validCoordinates = c.coveringRegion.filter(
      (coordinate) =>
        Number.isFinite(coordinate?.latitude) &&
        Number.isFinite(coordinate?.longitude),
    )
    if (!validCoordinates.length) return null
    const lats = validCoordinates.map((x) => x.latitude)
    const lngs = validCoordinates.map((x) => x.longitude)
    return {
      maxLat: Math.max(...lats),
      minLat: Math.min(...lats),
      maxLng: Math.max(...lngs),
      minLng: Math.min(...lngs),
    }
  }

  get mapCenter() {
    const c = this.camera
    if (!c) return null
    const { latitude, longitude, zoom } = c
    return {
      latitude,
      longitude,
      zoom,
      tilt: 0,
      bearing: 0,
    }
  }

  get isZoomMini() {
    const c = this.camera
    if (!c) return false
    return c.zoom <= 10
  }

  focusLocation(location: GpsLocation, zoom: LatLngDelta = DEFAULT_ZOOM) {
    this.mapRef.current?.animateToRegion({
      latitude: Number(location.lat),
      longitude: Number(location.lng),
      ...zoom,
    })
  }

  setLocationTrackingMode(mode: LocationTrackingMode) {
    this.mapRef.current?.setLocationTrackingMode(mode)
  }

  setCamera(c: NaverMapCamera) {
    this.camera = c
  }

  setIsReady(v: boolean) {
    this.isReady = v
  }
  onNonMarkerTouch() {
    this.selectedPlace = null
  }

  selectPlace(place: Place) {
    this.selectedPlace = place
    this.mapRef.current?.animateToCoordinate({
      latitude: Number(place.coord.lat),
      longitude: Number(place.coord.lng),
    })
  }
}
